// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadAppButton_button__02QOS","textContainer":"DownloadAppButton_textContainer__pWGac","iconContainer":"DownloadAppButton_iconContainer__2tCxU"};